import { render, staticRenderFns } from "./TenderBottomNav.vue?vue&type=template&id=033f324a"
import script from "./TenderBottomNav.vue?vue&type=script&lang=js"
export * from "./TenderBottomNav.vue?vue&type=script&lang=js"
import style0 from "./TenderBottomNav.vue?vue&type=style&index=0&id=033f324a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports